export function SessionsPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Sessions</h1>
        <p className="mt-2 text-muted-foreground">
          View and manage your writing sessions.
        </p>
      </div>

      <div className="rounded-lg border bg-card p-8 text-center text-card-foreground shadow-sm">
        <p className="text-muted-foreground">
          Session list will be displayed here.
        </p>
      </div>
    </div>
  );
}
